<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="loading"
        />
        <!-- <v-card v-if="error && !loading" width="650px">
          <v-ca
          <v-card-title>An error has occurred</v-card-title>
          <v-card-text>Item does not exist </v-card-text>
        </v-card> -->

        <v-alert
          prominent
          width="650"
          color="red"
          type="error"
          border="top"
          v-if="getError && !loading"
        >
          <v-row align="center">
            <v-col class="grow">
              {{
                $t(
                  "newsfeed.newsFeedAddEdit.anErrorHasOccurredThisItemIsCurrentlyUnavailableAgainLater"
                )
              }}
            </v-col>
          </v-row>
        </v-alert>

        <v-form
          ref="form"
          v-model="rules.valid"
          lazy-validation
          v-if="!loading && !getError"
        >
          <v-alert
            v-if="
              isEditView &&
              !editedItem.is_published &&
              !$moment(editedItem.date_published).isAfter()
            "
            prominent
            width="650"
            color="primary"
            border="top"
            type="info"
          >
            <v-row align="center">
              <v-col class="grow">
                {{
                  $t(
                    "newsfeed.newsFeedAddEdit.toPublishAnArticlePleasePressThePublishButtonBelow"
                  )
                }}
              </v-col>
            </v-row>
          </v-alert>

          <v-row class="mb-2">
            <v-col cols="12">
              <span> {{ $t("newsfeed.newsFeedAddEdit.content") }} </span>
            </v-col>
          </v-row>

          <v-card width="650px" class="mb-12" elevation="2" outlined>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-text-field
                      v-model="editedItem.title"
                      :label="$t('newsfeed.newsFeedAddEdit.title')"
                      :hint="$t('newsfeed.newsFeedAddEdit.required')"
                      color="primary"
                      required
                      autocomplete="off"
                      :rules="[rules.title]"
                      prepend-icon="mdi-subtitles-outline"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-textarea
                      v-model="editedItem.snippet"
                      :label="$t('newsfeed.newsFeedAddEdit.shortPreview')"
                      color="primary"
                      :hint="$t('newsfeed.newsFeedAddEdit.required')"
                      required
                      autocomplete="off"
                      rows="4"
                      counter="255"
                      :rules="[rules.snippet, rules.snippetLength(255)]"
                      prepend-icon="mdi-comment"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-text-field
                      v-model="editedItem.url"
                      :label="$t('newsfeed.newsFeedAddEdit.contentURL')"
                      color="primary"
                      :hint="$t('newsfeed.newsFeedAddEdit.required')"
                      autocomplete="off"
                      :rules="[rules.url, rules.urlValid]"
                      prepend-icon="mdi-link"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <direct-file-upload
                      :multiple="false"
                      :files="isEditView ? [editedItem.main_image] : []"
                      @saved="handleDirectUploadFiles"
                      :loading.sync="loading"
                      :hint="$t('newsfeed.newsFeedAddEdit.bestSize')"
                      persistent-hint
                      asset-type="image_asset"
                      ref="directFileUpload"
                      :label="$t('newsfeed.newsFeedAddEdit.imageThumbnail')"
                      prepend-icon="mdi-file-image"
                    >
                      <template v-slot:default="{ file }">
                        <v-menu v-model="menu" offset-x>
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              style="cursor: pointer; position: absolute"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="menu = true"
                              @mouseleave="menu = false"
                            >
                              <v-icon class="mr-2">mdi-file-image</v-icon>
                              {{ file.name }}
                            </div>
                          </template>

                          <v-card class="pa-2">
                            <v-list>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-img
                                    max-height="150"
                                    max-width="250"
                                    :src="
                                      typeof file.src === 'undefined'
                                        ? getResizedImageSrc(file.link)
                                        : file.src
                                    "
                                  ></v-img>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-menu>
                      </template>
                    </direct-file-upload>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <date-picker
                      :date-label="$t('newsfeed.newsFeedAddEdit.publishDate')"
                      :provider-date.sync="editedItem.date_published"
                      prepend-icon="mdi-calendar-range"
                      :prevent-past-date="true"
                      :clearable="true"
                    ></date-picker>
                  </v-col>

                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-checkbox
                      class="mb-0 pb-0"
                      v-model="editedItem.pinned"
                      :label="$t('newsfeed.newsFeedAddEdit.pinnedOnTop')"
                      color="primary"
                      prepend-icon="mdi-bookmark-check"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>

          <v-row class="mb-2">
            <v-col cols="12">
              <span> {{ $t("newsfeed.newsFeedAddEdit.audience") }} </span>
            </v-col>
          </v-row>

          <v-card width="650px" class="mb-12" elevation="2" outlined>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12" sm="12" md="12" lg="12" class="mb-4">
                    {{
                      $t("newsfeed.newsFeedAddEdit.estimatedAudienceSize", {
                        count: editedItem.estimated.isPartialEstimate
                          ? `> ${editedItem.estimated.count}`
                          : editedItem.estimated.count,
                      })
                    }}
                    {{
                      $tc(
                        "newsfeed.newsFeedAddEdit.boatsCount",
                        editedItem.estimated.count,
                        {
                          count: editedItem.estimated.isPartialEstimate
                            ? `> ${editedItem.estimated.count}`
                            : editedItem.estimated.count,
                        }
                      )
                    }}
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <brand-tree-view-selector
                      :initial-brands="editedItem.audience_crm_groups"
                      :query-parameters="{ newsfeed_permissions: 'write' }"
                      :error="postError"
                      @change="setAudienceCrmGroup"
                    ></brand-tree-view-selector>

                    <v-select
                      :items="connectivityOptions"
                      v-model="editedItem.audience_connectivity"
                      :label="$t('newsfeed.newsFeedAddEdit.boats')"
                      item-text="title"
                      item-value="value"
                      @change="setAudience"
                      prepend-icon="mdi-connection"
                    ></v-select>

                    <v-select
                      :items="userTypeOptions"
                      v-model="editedItem.audience_user_type"
                      :label="$t('newsfeed.newsFeedAddEdit.users')"
                      item-text="title"
                      item-value="value"
                      @change="setAudience"
                      prepend-icon="mdi-account"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
          <v-app-bar
            app
            color="white"
            style="z-index: 100; height: 64px; bottom: 0; top: unset"
            bottom
          >
            <v-layout align-center justify-center>
              <v-card flat width="650">
                <v-card-actions>
                  <v-btn
                    text
                    @click="remove"
                    v-if="editedItem.is_removable"
                    color="red"
                  >
                    <v-icon small class="mr-2"> mdi-delete</v-icon>
                    {{ $t("newsfeed.newsFeedAddEdit.delete") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close()">{{
                    $t("newsfeed.newsFeedAddEdit.cancel")
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    data-cy="modelsCancelBtn"
                    text
                    @click="setSaveDialogAsDraft(false)"
                    class="mr-2"
                    >{{ $t("newsfeed.newsFeedAddEdit.saveAsDraft") }}</v-btn
                  >
                  <v-btn
                    color="primary"
                    @click="setSaveDialogAsPublish(true)"
                    class="mr-2"
                    ><span
                      v-if="
                        editedItem.date_published !== null &&
                        $moment(editedItem.date_published).isAfter()
                      "
                      >{{
                        $t("newsfeed.newsFeedAddEdit.scheduleForPublishing")
                      }}</span
                    ><span v-else>{{
                      $t("newsfeed.newsFeedAddEdit.publish")
                    }}</span></v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-layout>
          </v-app-bar>
        </v-form>
      </v-layout>
      <news-feed-saving-dialog
        v-if="saveDialog.active"
        :dialog="saveDialog"
        @save="handleSaveDialog"
      ></news-feed-saving-dialog>
      <delete-dialog
        :dialog="deleteDialog.active"
        :item="deleteDialog.title"
        @agree="handleRemove"
        v-show="false"
      />
    </v-container>
  </v-content>
</template>

<script>
import api from "@/utils/api";
import snackbar from "@/utils/snackbar";
import DatePicker from "@/components/pickers/DatePicker";
import BrandTreeViewSelector from "@/components/selectors/BrandTreeViewSelector";
import DirectFileUpload from "@/components/miscellaneous/DirectFileUpload.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import NewsFeedSavingDialog from "@/components/dialogs/NewsFeedSavingDialog.vue";
import restrictions from "../../utils/restrictions";

export default {
  components: {
    DatePicker,
    BrandTreeViewSelector,
    DirectFileUpload,
    DeleteDialog,
    NewsFeedSavingDialog,
  },
  data: () => ({
    loading: true,
    isEditView: false,
    postError: false,
    getError: false,
    editedItem: {
      date_published: null,
      audience_crm_groups: [],
      audience_connectivity: "ALL",
      audience_user_type: "ALL",
      estimated: { count: 0, index: 0 },
      url: "",
      status: "new",
    },
    saveDialog: {
      active: false,
      title: "",
      text: "",
      accept: "",
      deny: "",
      publish: false,
      date: null,
    },
    updateDropFile: 0,
    menu: false,
    deleteDialog: { active: false, title: "" },
    rules: {},
    connectivityOptions: [],
    userTypeOptions: [],
    currentEstimateCall: null,
    audienceTimeout: null,
  }),

  created() {
    this.setInitalData();
    typeof this.$route.params.id !== "undefined"
      ? this.fetchNewsFeed()
      : (this.loading = false);
  },
  methods: {
    setInitalData() {
      this.rules = {
        valid: true,
        snippet: (v) =>
          !!v || this.$t("newsfeed.newsFeedAddEdit.shortPreviewIsRequired"),
        snippetLength: (len) => (v) =>
          (v || "").length <= len ||
          this.$t(
            "newsfeed.newsFeedAddEdit.invalidCharacterLengthRequiredMaximumOf",
            { length: len }
          ),
        title: (v) =>
          !!v || this.$t("newsfeed.newsFeedAddEdit.titleIsRequired"),
        url: (v) =>
          !!v || this.$t("newsfeed.newsFeedAddEdit.contentUrlIsRequired"),
        urlValid: (v) =>
          /https?:[0-9]*\/\/[\w!?+\-_~=;.,*&@#$%()'[\]]+/.test(v) ||
          this.$t("newsfeed.newsFeedAddEdit.urlMustBeValid"),
      };

      this.connectivityOptions = [
        { title: this.$t("newsfeed.newsFeedAddEdit.all"), value: "ALL" },
        {
          title: this.$t("newsfeed.newsFeedAddEdit.connected"),
          value: "connected",
        },
        {
          title: this.$t("newsfeed.newsFeedAddEdit.nonConnected"),
          value: "non_connected",
        },
      ];

      this.userTypeOptions = [
        { title: this.$t("newsfeed.newsFeedAddEdit.all"), value: "ALL" },
        { title: this.$t("newsfeed.newsFeedAddEdit.owner"), value: "OW" },
        { title: this.$t("newsfeed.newsFeedAddEdit.guest"), value: "GU" },
      ];

      if (restrictions.canUseUserFeature("can_use_demo_mode_in_newsfeed")) {
        this.userTypeOptions.push({
          title: this.$t("newsfeed.newsFeedAddEdit.demo"),
          value: "DEMO",
        });
      }
    },
    getResizedImageSrc(src) {
      if (!src) {
        return "";
      }

      const extansion =
        src.substring(src.lastIndexOf(".") + 1, src.length) || src;

      return `${src.split(extansion)[0]}250x150.${extansion}`;
    },
    fetchNewsFeed() {
      let getCurrentArticleStatus = (item) => {
        if (!item.confirmed_for_publishing || item.date_published === null)
          return "draft";

        if (
          item.confirmed_for_publishing &&
          this.$moment(item.date_published).isAfter()
        )
          return "scheduled";

        if (
          item.confirmed_for_publishing &&
          this.$moment(item.date_published).isBefore()
        )
          return "published";

        return "undefined";
      };
      this.loading = true;
      this.isEditView = true;
      api
        .getNewsFeed(this.$route.params.id)
        .then((resp) => {
          this.editedItem = {
            ...this.editedItem,
            ...resp.data,
            status: getCurrentArticleStatus(resp.data),
            audience_connectivity:
              resp.data.audience_connectivity !== null
                ? resp.data.audience_connectivity[0]
                : null,
            audience_user_type:
              resp.data.audience_user_type !== null
                ? resp.data.audience_user_type[0]
                : null,
          };
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.getError = true;
          setTimeout(() => {
            this.close();
          }, 5000);
        });
    },

    getEstimateAudience(data) {
      if (this.currentEstimateCall) {
        this.currentEstimateCall.cancel = true;
        this.currentEstimateCall = null;
      }

      const callId = Date.now();
      this.currentEstimateCall = { id: callId, cancel: false };

      // NOTE: batch size is hardcoded to 65 because the maxiumum length of the path is 4096
      const batchSize = 65;

      if (this.editedItem.audience_crm_group_uuids.length <= batchSize) {
        const currentCall = this.currentEstimateCall;
        api
          .getEstimateAudience(data)
          .then((resp) => {
            if (
              currentCall &&
              !currentCall.cancel &&
              this.currentEstimateCall &&
              this.currentEstimateCall.id === currentCall.id
            ) {
              this.editedItem.estimated = { ...resp.data };
            }
          })
          .catch((err) => {
            if (
              currentCall &&
              !currentCall.cancel &&
              this.currentEstimateCall &&
              this.currentEstimateCall.id === currentCall.id
            ) {
              this.editedItem.estimated = { index: 0, count: 0 };
              console.error("Failed to get audience estimate:", err);
            }
          });
        return;
      }

      const allUuids = this.editedItem.audience_crm_group_uuids;
      const batches = [];

      for (let i = 0; i < allUuids.length; i += batchSize) {
        batches.push(allUuids.slice(i, i + batchSize));
      }

      const batchesToProcess = batches.slice(0, 5);
      const isPartialEstimate = batches.length > 5;

      const currentCall = this.currentEstimateCall;
      const batchPromises = batchesToProcess.map((batch, index) => {
        const originalUuids = this.editedItem.audience_crm_group_uuids;
        this.editedItem.audience_crm_group_uuids = batch;

        const batchParams = this.getEstimateAudienceParameters();
        this.editedItem.audience_crm_group_uuids = originalUuids;

        return api.getEstimateAudience(batchParams);
      });

      Promise.all(batchPromises)
        .then((results) => {
          if (
            currentCall &&
            !currentCall.cancel &&
            this.currentEstimateCall &&
            this.currentEstimateCall.id === currentCall.id
          ) {
            const totalCount = results.reduce((sum, resp) => {
              return sum + (resp.data.count || 0);
            }, 0);

            const totalIndex = results.reduce((sum, resp) => {
              return sum + (resp.data.index || 0);
            }, 0);

            this.editedItem.estimated = {
              count: totalCount,
              index: Math.round(totalIndex / results.length),
              isPartialEstimate: isPartialEstimate,
            };
          }
        })
        .catch((err) => {
          if (
            currentCall &&
            !currentCall.cancel &&
            this.currentEstimateCall &&
            this.currentEstimateCall.id === currentCall.id
          ) {
            this.editedItem.estimated = { index: 0, count: 0 };
            console.warn("Failed to get batch audience estimate:", err);
          }
        });
    },
    getEstimateAudienceParameters() {
      return `${
        this.editedItem.audience_crm_group_uuids
          .map((n, index) => `audience_brand_uuids[${index}]=${n}`)
          .join("&") + "&"
      }${
        this.editedItem.audience_connectivity
          ? "audience_connectivity=" + this.editedItem.audience_connectivity
          : ""
      }&${
        this.editedItem.audience_user_type
          ? "audience_user_type=" + this.editedItem.audience_user_type
          : ""
      }`;
    },
    setAudienceCrmGroup(event) {
      this.editedItem.audience_crm_group_uuids = event;
      this.setAudience();
    },
    setAudience() {
      if (this.audienceTimeout) {
        clearTimeout(this.audienceTimeout);
      }

      this.audienceTimeout = setTimeout(() => {
        this.editedItem.audience_crm_group_uuids.length !== 0
          ? this.getEstimateAudience(this.getEstimateAudienceParameters())
          : (this.editedItem.estimated = { index: 0, count: 0 });
      }, 300);
    },
    handleDirectUploadFiles(uuid) {
      const { fileUuids } = uuid;
      this.editedItem.main_image_uuid = fileUuids[0];
      this.isEditView ? this.update() : this.create();
    },
    update(published) {
      //API REQUIRES ARRAY
      this.editedItem.audience_connectivity = [
        this.editedItem.audience_connectivity,
      ];

      if (this.editedItem.date_published === null) {
        this.editedItem.confirmed_for_publishing = false;
      }

      if (published) {
        this.editedItem.date_published = this.editedItem.date_published
          ? this.editedItem.date_published
          : new Date();
      }

      this.editedItem.audience_user_type = [this.editedItem.audience_user_type];

      api
        .updateNewsFeed(this.$route.params.id, this.editedItem)
        .then((resp) => {
          if (published) {
            snackbar.success(
              this.$t("utils.snackbar.success.articleSuccessfullyPublished", {
                title: this.editedItem.title,
              })
            );
          } else {
            snackbar.success(
              this.$t("utils.snackbar.success.articleSuccessfullySaved", {
                title: this.editedItem.title,
              })
            );
          }
          this.close();
        })
        .catch((err) => {
          this.postError = true;
          this.loading = false;
          this.editedItem.audience_connectivity =
            this.editedItem.audience_connectivity[0];
          this.editedItem.audience_user_type =
            this.editedItem.audience_user_type[0];

          if (published) {
            this.editedItem.date_published = this.editedItem.date_published
              ? this.editedItem.date_published
              : this.$moment().toISOString().substring(0, 10);
          }
        });
    },

    create(published) {
      //API REQUIRES ARRAY
      this.editedItem.audience_connectivity = [
        this.editedItem.audience_connectivity,
      ];

      this.editedItem.audience_user_type = [this.editedItem.audience_user_type];

      if (published) {
        this.editedItem.date_published = this.editedItem.date_published
          ? this.editedItem.date_published
          : new Date();
      }

      api
        .createNewsFeed(this.editedItem)
        .then((resp) => {
          if (published) {
            snackbar.success(
              this.$t("utils.snackbar.success.articleSuccessfullyPublished", {
                title: this.editedItem.title,
              })
            );
          } else {
            snackbar.success(
              this.$t("utils.snackbar.success.articleSuccessfullySaved", {
                title: this.editedItem.title,
              })
            );
          }
          this.close();
        })
        .catch((err) => {
          this.postError = true;
          this.loading = false;
          this.editedItem.audience_connectivity =
            this.editedItem.audience_connectivity[0];
          this.editedItem.audience_user_type =
            this.editedItem.audience_user_type[0];

          if (published) {
            this.editedItem.date_published = this.editedItem.date_published
              ? this.editedItem.date_published
              : this.$moment().toISOString().substring(0, 10);
          }
        });
    },

    handleSaveDialog(data) {
      if (data.action === false) {
        this.saveDialog = {
          active: false,
          title: "",
          text: "",
          accept: "",
          deny: "",
          publish: false,
          date: null,
        };
        return;
      }
      if (!data.data.publish) {
        this.save(false);
      } else {
        if (data.data.date !== null) {
          this.editedItem.date_published = data.data.date;
        }
        this.save(true);
      }

      this.saveDialog = {
        active: false,
        title: "",
        text: "",
        accept: "",
        deny: "",
        publish: false,
        date: null,
      };
      return;
    },
    save(published = false) {
      if (!this.$refs.form.validate()) {
        snackbar.error(
          this.$t(
            "utils.snackbar.error.theFormIsIncompletePleaseCompleteTheFormBeforeSaving"
          )
        );
        return;
      }

      if (published) {
        this.editedItem.confirmed_for_publishing = true;
      } else {
        this.editedItem.confirmed_for_publishing = false;
      }

      if (this.$refs.directFileUpload.dirty) {
        //Order of code below is important!!
        this.$refs.directFileUpload.save().then((resp) => {
          this.handleDirectUploadFiles(resp);
        });
        this.loading = true;
      } else {
        this.loading = true;
        this.isEditView ? this.update(published) : this.create(published);
      }
    },
    setSaveDialogAsDraft() {
      if (this.editedItem.status === "published") {
        this.saveDialog = {
          title: this.$t(
            "newsfeed.newsFeedAddEdit.areYouSureYouWishToUnpublishThisArticle"
          ),
          accept: this.$t("newsfeed.newsFeedAddEdit.yesUnpublish"),
          deny: this.$t("newsfeed.newsFeedAddEdit.no"),
          publish: false,
          active: true,
          date: null,
        };
      } else if (this.editedItem.status === "scheduled") {
        this.saveDialog = {
          title: this.$t(
            "newsfeed.newsFeedAddEdit.areYouSureYouWishToUnscheduleThisArticlesPublication"
          ),
          accept: this.$t("newsfeed.newsFeedAddEdit.yesUnschedule"),
          deny: this.$t("newsfeed.newsFeedAddEdit.no"),
          publish: false,
          active: true,
          date: null,
        };
      } else {
        this.save(false);
      }
    },
    setSaveDialogAsPublish() {
      if (this.editedItem.date_published === null) {
        this.saveDialog = {
          title: this.$t(
            "newsfeed.newsFeedAddEdit.areYouSureYouWishToPublishThisArticleNow"
          ),
          accept: this.$t("newsfeed.newsFeedAddEdit.yesPublish"),
          deny: this.$t("newsfeed.newsFeedAddEdit.no"),
          publish: true,
          active: true,
          date: new Date(),
        };
      } else if (this.$moment(this.editedItem.date_published).isBefore()) {
        this.saveDialog = {
          title: this.$t(
            "newsfeed.newsFeedAddEdit.areYouSureYouWishToPublishThisArticleWithDate",
            {
              date: this.$moment(this.editedItem.date_published)
                .toISOString()
                .substring(0, 10),
            }
          ),
          accept: this.$t("newsfeed.newsFeedAddEdit.yesPublish"),
          deny: this.$t("newsfeed.newsFeedAddEdit.no"),
          publish: true,
          active: true,
          date: null,
        };
      } else if (this.$moment(this.editedItem.date_published).isAfter()) {
        this.saveDialog = {
          title: this.$t(
            "newsfeed.newsFeedAddEdit.areYouSureYouWishToScheduleThisArticleForPublicationOn",
            {
              date: this.$moment(this.editedItem.date_published)
                .toISOString()
                .substring(0, 10),
            }
          ),
          accept: this.$t("newsfeed.newsFeedAddEdit.yesSchedule"),
          deny: this.$t("newsfeed.newsFeedAddEdit.no"),
          publish: true,
          active: true,
          date: null,
        };
      }
    },
    close() {
      this.$router.push({
        name: "newsfeed",
      });
      // this.loading = false;
    },
    remove() {
      this.deleteDialog = {
        active: true,
        title: this.editedItem.title,
        item: this.editedItem,
      };
    },
    handleRemove(agreed) {
      if (agreed) {
        api.deleteNewsFeed(this.deleteDialog.item.uuid).then((resp) => {
          snackbar.success(
            this.$t("utils.snackbar.success.successfullyDeleted")
          );
          this.close();
        });
      }
      this.deleteDialog = { active: false, title: "", item: null };
    },
  },
};
</script>
<style>
.bottom-navigation {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 54px;
  width: 100%;
  color: white;
}
</style>
